<template>
    <div class="userLogin">
        <div class="down">
            <div class="androidDown" @click.prevent="userQuerySIM1">
                <img src="@/assets/home/an.png" alt="">
                安卓下载
            </div>
            <div class="iosDown" @click.prevent="userQuerySIM12">
                <img src="@/assets/home/IOS.png" alt="">苹果下载
            </div>
            <div class="jc" @click.prevent="userQuerySIM13">
                <img src="@/assets/home/down.png" alt="">
            </div>
        </div>
        <div class="shareit" v-if="showTitle">
            <img class="arrow" src="@/assets/img/arrowhead.png" />
            <div class="follow">
                请点击右上角选择 在游览器打开 进行下载,<br />
            </div>
        </div>


    </div>
</template>

<script>

import { Dialog } from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js'
export default {
    data() {
        return {
            showTitle: false,
            appLoad: false,
        }
    },
    methods: {
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;
            cb(results);
        },
        createFilter(queryString) {
            return (listAll) => {
                return (listAll.indexOf(queryString) == 0);
            };
        },
        handleSelect(item) {
            this.iccid = item
        },
        userQuerySIM13() {
            this.$router.replace('/loadp');

        },
        userQuerySIM12() {
            Dialog.confirm({
                title: "应用商店下载提示",
                message:
                    "苹果用户可直接到应用商城下载“小象通信”APP，也可以点击 确定 继续网页下载。"
            }).then((action) => {
                if (action == "confirm") {
                    if (this.appLoad) {
                        this.showTitle = true;
                    } else {
                        window.location.href = 'http://app.szxxtx.com/pingguo/app.mobileconfig'

                    }
                }
            }).catch(() => { });

        },
        userQuerySIM1() {
            if (this.appLoad) {
                this.showTitle = true;
            } else {
                window.location.href = 'http://app.szxxtx.com/anzuo/app.apk'
            }
        },
        // goto(path){
        //     //广告点击统计
        //     wxRequest("link/click",{url: path}, "get").then(res => {
        //         window.location.href = path;
        //     });

        // },


    },
    created() {
        var ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.appLoad = true;
        }

    },

    mounted() {

    },


    beforeDestory() {

    }
}
</script>


<style scoped lang="less">
.userLogin {
    background: url('~@/assets/home/bg.jpg') no-repeat;
    background-size: 100% 100%;
    height: 100%;
    position: relative;

    .down {
        position: absolute;
        bottom: 20px;
        left: 25%;
    }

    .androidDown {
        width: 200px;
        background: #2b98ff;
        border-radius: 22px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        img {
            width: 25px;
        }
    }

    .iosDown {
        width: 200px;
        background: #2b98ff;
        border-radius: 22px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
        justify-content: center;
        color: #fff;
        display: flex;
        align-items: center;

        img {
            width: 30px;
        }
    }

    .jc {
        width: 120px;
        margin: auto;
        margin-top: 10px;

        img {
            width: 100%;
        }
    }
}

.shareit {
    -webkit-user-select: none;
    position: fixed;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    text-align: center;
    top: 0;
    left: 0;
    z-index: 999;
}

.shareit img {
    max-width: 100%;
}

.arrow {
    width: 100px;
    height: 150px;
    position: absolute;
    right: 5%;
    top: 1%;
}

.follow {
    margin-right: 6px;
    margin-left: 30px;
    width: 90%;
    line-height: 30px;
    text-decoration: none;
    font-size: 18px;
    color: white;
    float: left;
    margin-top: 180px;
}
</style>